<!------------------------------

    Table Wrapper

------------------------------->
<h3>{{ 'lang.shareOfVoice.distinctCampaigns' | translate }}</h3>
<sb-table-wrapper-new
  headline="{{'lang.shareOfVoice.distinctCampaigns' | translate}}"
  [isInIntegratedContext]="true"
  [itemsData]="_campaigns"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'_campaigns'">

  <!------------------------------

        Filter Panel

  ------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.timingProgress' | translate }}
      </th>
      <th *ngPermissions="permissionService.Permission.ds_cm_reporting">
        {{ 'lang.globals.playoutPulse' | translate }}
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.actions' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-campaign>
    <tr (mouseover)="campaign.interval = 2000" (mouseout)="campaign.interval = 0"
        [ngClass]="{'tw-opacity-50' : !campaign.active}">
      <td>
        <div class="d-flex align-items-center">
          <sb-action-required class="mr-4" [bookingStatus]="campaign.bookingStatus"></sb-action-required>
          <sb-comp-image-name-wrapper [still]="true" [medium]="campaign?.preview" [tooltipInterval]="campaign.interval">
            <sb-comp-link
              firstLine
              [title]="campaign.name | truncate : 23"
              [link]="util.RoutingID.commercials"
              [pathParams]="[{id: 'campaignID', value:campaign?.id}]"
              [tooltip]="'lang.globals.openDetails' | translate">
            </sb-comp-link>
            <span secondLine>
                  {{ campaign?.commercialCount?.Present }} {{ campaign?.commercialCount?.Present === 1 ? ('lang.globals.commercial'|translate) : ('lang.globals.commercials'|translate) }}
                </span>
            <span thirdLine [classes]="'d-xxxl-none'">{{ campaign.customer.name }}</span>
          </sb-comp-image-name-wrapper>
        </div>
      </td>
      <td>
        <sb-progressbar [bigProgress]="false"
                        [width]="util.getTimeframePercentage(campaign?.from,campaign?.till)" mode="progressBar">
                    <span style="font-size: .9rem;" *ngIf="campaign.timingStatus==='Future'"
                          class="blue font-weight-bold">{{ 'lang.globals.planned' | translate }}</span>
          <span style="font-size: .9rem;" *ngIf="campaign.timingStatus==='Present'"
                class="green font-weight-bold">{{ 'lang.globals.running' | translate }}</span>
          <span style="font-size: .9rem;" *ngIf="campaign.timingStatus==='Past'"
                class="grey font-weight-bold">{{ 'lang.globals.expired' | translate }}</span>
          <span style="font-size: .9rem;" *ngIf="campaign.timingStatus==='Unknown'"
                class="grey font-weight-bold">{{ 'lang.globals.noTiming' | translate }}</span>
        </sb-progressbar>
        <div class="d-flex justify-content-between">
          <span style="width: 95px"
                class="text-start font-weight-bold">{{ campaign?.from?.toString() | date: 'dd.MM.yy HH:mm' }}</span>
          <span style="width: 10px" class="mx-1 text-center">-</span>
          <span style="width: 95px"
                class="text-end font-weight-bold">{{ campaign?.till?.toString() | date: 'dd.MM.yy HH:mm' }}</span>
        </div>
      </td>
      <td
        *ngIf="permissionService.hasPermission(permissionService.Permission.ds_cm_reporting)"
      >
        <div *ngIf="campaign?.reporting?.loadingDone">
          <sb-line-small-chart #lineChart [chartData]="campaign?.reporting">
          </sb-line-small-chart>
        </div>
      </td>
      <td class="tr bw sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="campaign.sbButtons ?? []"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
</sb-table-wrapper-new>
